var _path, _ellipse, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0568 2.00008C8.54687 1.9859 5.28557 3.80704 3.4605 6.80035C1.63543 9.79366 1.51292 13.5223 3.13757 16.6286L3.33789 17.0191C3.50209 17.3264 3.53644 17.6864 3.43329 18.0191C3.14742 18.7784 2.90849 19.5544 2.71784 20.3429C2.71784 20.7429 2.83231 20.9715 3.26158 20.962C4.0219 20.7941 4.77068 20.5777 5.50332 20.3143C5.81886 20.2274 6.15437 20.2475 6.45725 20.3715C6.73389 20.5048 7.2967 20.8477 7.31578 20.8477C10.9915 22.7804 15.4808 22.2472 18.5998 19.5074C21.7187 16.7676 22.8199 12.39 21.3676 8.50403C19.9153 4.61809 16.2111 2.03053 12.0568 2.00008V2.00008Z",
    stroke: "#37B97A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 7.28727,
    cy: 12.0001,
    rx: 0.476965,
    ry: 0.47619,
    fill: "#37B97A",
    stroke: "#37B97A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 12.0568,
    cy: 12.0001,
    rx: 0.476965,
    ry: 0.47619,
    fill: "#37B97A",
    stroke: "#37B97A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 16.8266,
    cy: 12.0001,
    rx: 0.476965,
    ry: 0.47619,
    fill: "#37B97A",
    stroke: "#37B97A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/commentIcon.da6538f3fb7bc9ebb54a378b821532e8.svg";
export { ForwardRef as ReactComponent };